import React from 'react';
import { CrudPage } from '@restavo/crud';
import { useIssuesPage } from 'src/features/issues';

const AllIssues = React.memo(
  ({ employee, dish, operation }: { employee?: boolean; dish?: boolean; operation?: boolean }) => {
    const { page } = useIssuesPage({ employee, dish, operation });
    return <CrudPage {...page} />;
  }
);

export default AllIssues;
